import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const BcrumbBannerTwo = ({
  title,
  noimg,
  paragraph,
  mainThumb,
  bannerData,
  color,
  titleCategory,
  subtitle,
  page, // Add page prop for breadcrumb
}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Define special titles that need different styling
  const specialTitles = [
    "Gallery",
    "Who We Are",
    "Mission & Vision",
    "Occupational Health & Safety",
  ];
  const isSpecialTitle = specialTitles.includes(title);

  const responsivePadding = isSpecialTitle
    ? windowWidth <= 768
      ? "140px 0 20px"
      : "200px 0 20px"
    : windowWidth <= 768
    ? "140px 0 70px"
    : "200px 0 70px";

  // Create a default slides array using the single item props if bannerData is not provided
  const slides = bannerData || [
    {
      title: title,
      paragraph: paragraph,
      mainThumb: mainThumb,
    },
  ];

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    pauseOnHover: false,
    dotsClass: "slick-dots custom-dots",
  };

  return (
    <div className="breadcrum-area" style={{ padding: responsivePadding }}>
      <div className="container">
        {/* Add Breadcrumb Navigation */}
        <div className="breadcrumb" style={{ marginBottom: "20px" }}>
          <ul className="list-unstyled">
            <li>
              <Link
                to={process.env.PUBLIC_URL + "/"}
                style={{ color: "var(--color-text-dark)" }}
              >
                Home
              </Link>
            </li>
            {page && (
              <li
                className="active"
                dangerouslySetInnerHTML={{ __html: page }}
              ></li>
            )}
          </ul>
          {titleCategory && (
            <h1
              className="title h2"
              dangerouslySetInnerHTML={{ __html: titleCategory }}
              style={{
                color: "",
              }}
            ></h1>
          )}
          {subtitle && (
            <span className="" style={{ 
              color: "var(--color-text-dark)" ,
              marginBottom: "60px",
            }}>
              {subtitle}{" "}
            </span>
          )}
        </div>

        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div key={index}>
              <div className="row align-items-center">
                <div className={noimg ? "col-lg-7" : "col-lg-6"}>
                  <div className="section-heading heading-left">
                    <h1
                      style={{ color: color }}
                      className="title h2"
                      dangerouslySetInnerHTML={{ __html: slide.title }}
                    ></h1>
                    <p
                      style={{ width: "100%" }}
                      dangerouslySetInnerHTML={{ __html: slide.paragraph }}
                    ></p>
                  </div>
                </div>
                <div className="col-lg-6">
                  {slide.mainThumb && !noimg && (
                    <div className="banner-thumbnail d-flex justify-content-md-center">
                      <img
                        src={process.env.PUBLIC_URL + slide.mainThumb}
                        alt="Illustration"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

// Add default props
BcrumbBannerTwo.defaultProps = {
  title: "",
  paragraph: "",
  mainThumb: "",
  page: "", // Default for the breadcrumb page
};

export default BcrumbBannerTwo;
